<div>
  {{ data }}
</div>
